import React from 'react';

interface DetailSplitProps {
  /** Main content area (left / full-width when collapsed). */
  children: React.ReactNode;
  /** Rail content (right sticky column). */
  rail: React.ReactNode;
  /** Rail column width in px. Default 340. */
  railWidth?: number;
  className?: string;
}

/**
 * Two-column detail layout per comp .detail-split + .sticky-rail.
 *
 * ≥ 1180px: minmax(0,1fr) <railWidth>px side-by-side, align-items start.
 * < 1180px: single column; rail stacks below main.
 *
 * The 1180px collapse is handled by the global rule in index.css:
 *   @media (max-width: 1179px) { .detail-split { grid-template-columns: 1fr !important; } }
 * The sentinel class "detail-split" is applied to this element so that rule fires.
 * The inline style only carries geometry (grid-template-columns) — never colors.
 */
export const DetailSplit: React.FC<DetailSplitProps> = ({ children, rail, railWidth = 340, className = '' }) => {
  return (
    <div
      className={`detail-split grid gap-4 items-start w-full ${className}`}
      style={{ gridTemplateColumns: `minmax(0,1fr) ${railWidth}px` }}
    >
      {/* Main content */}
      <div className="min-w-0">{children}</div>

      {/* Sticky rail — stacks its children with gap */}
      <div className="flex flex-col gap-4" style={{ position: 'sticky', top: '1rem', alignSelf: 'start' }}>
        {rail}
      </div>
    </div>
  );
};
